import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';

const ViewInboundModal = ({ isOpen, handleClose, row }) => {
  if (!row) return null;

  return (
    <Modal isOpen={isOpen} backdrop="static" size="md">
      <ModalHeader toggle={handleClose}>Received Message</ModalHeader>
      <ModalBody>
        <Row className="mb-3" style={{ fontSize: '0.9rem' }}>
          <Col md="6">
            <span className="text-muted">From</span>
            <div><strong>{row.mobileNumber || '—'}</strong></div>
          </Col>
          <Col md="6">
            <span className="text-muted">Received At</span>
            <div><strong>{row.sentAt || '—'}</strong></div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <span className="text-muted" style={{ fontSize: '0.9rem' }}>Message</span>
            <div
              style={{
                marginTop: '0.4rem',
                padding: '0.75rem 1rem',
                background: '#f8f9fa',
                borderRadius: '6px',
                fontSize: '0.95rem',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                lineHeight: '1.5'
              }}
            >
              {row._fullMessage || '—'}
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ViewInboundModal;
